import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { generateChallengeAction } from '@/features/2fa/store/actions/auth2Fa.actions';

export default function useGenerateChallenge() {
  const dispatch = useDispatch();

  const generateChallenge = useCallback(
    (onFinish?: (challenge: string) => void) => {
      dispatch(generateChallengeAction(onFinish));
    },
    [dispatch],
  );

  return { generateChallenge };
}
